/* Product-page upsell: selection only; the product form owns cart requests. */
(() => {
  if (customElements.get('cca-product-upsell')) return;

  class ProductUpsell extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.refresh();
      this.addEventListener('change', this.onChange);
      this.refresh();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.toggleCheckout(false);
    }

    get item() {
      const checkbox = this.querySelector('.lumin-upsell-checkbox');
      const selector = this.querySelector('[data-variant-selector]');
      const option = selector?.selectedOptions[0];
      const id = selector ? option?.value : this.dataset.variantId;
      if (!checkbox?.checked || checkbox.disabled || option?.disabled || !id) return null;
      return { id, quantity: 1 };
    }

    refresh() {
      const option = this.querySelector('[data-variant-selector]')?.selectedOptions[0];
      if (option) {
        const price = this.querySelector('[data-variant-price]');
        const compare = this.querySelector('[data-variant-compare-price]');
        const image = this.querySelector('[data-variant-image]');
        if (price) price.innerHTML = option.dataset.variantPrice || '';
        if (compare) compare.innerHTML = option.dataset.variantComparePrice || '';
        if (image && option.dataset.variantImageUrl) {
          image.src = option.dataset.variantImageUrl;
          image.alt = option.dataset.variantImageAlt || '';
        }
      }
      this.toggleCheckout(Boolean(this.item));
    }

    toggleCheckout(selected) {
      // Accelerated checkout skips the Ajax form and cannot include this extra item.
      // Keep it available again as soon as the customer deselects the upsell.
      const scope = this.closest('.product');
      if (!scope || window.Shopify?.designMode) return;
      scope.classList.toggle('cca-upsell-selected', selected);
    }
  }

  window.CCAUpsell = {
    collect(scope) {
      if (!scope || window.Shopify?.designMode) return [];
      return Array.from(scope.querySelectorAll('cca-product-upsell'))
        .map((block) => block.item).filter(Boolean);
    },
    appendToForm(formData, scope) {
      const items = this.collect(scope);
      if (!items.length) return formData;
      const result = new FormData();
      // Preserve gift-card fields, custom properties, quantity and selling plans.
      for (const [key, value] of formData.entries()) {
        if (['id', 'quantity', 'selling_plan'].includes(key)) {
          result.append(`items[0][${key}]`, value);
        } else if (key.startsWith('properties[')) {
          result.append(`items[0][properties]${key.slice(10)}`, value);
        } else {
          result.append(key, value);
        }
      }
      items.forEach((item, index) => {
        result.append(`items[${index + 1}][id]`, item.id);
        result.append(`items[${index + 1}][quantity]`, item.quantity);
      });
      return result;
    }
  };
  customElements.define('cca-product-upsell', ProductUpsell);
})();
